<script lang="ts">
  export let isOpen = false
  export let imageUrl = ''
  export let imageAlt = ''

  export let onClose: () => void = () => {}
</script>

{#if isOpen && imageUrl}
  <div
    class="fixed inset-0 z-[100] bg-black/95 p-4"
    on:click={onClose}
  >
    <button
      type="button"
      class="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/10 text-2xl leading-none text-white"
      on:click|stopPropagation={onClose}
      aria-label="Close image preview"
    >
      ×
    </button>

    <div class="flex h-full w-full items-center justify-center">
      <img
        src={imageUrl}
        alt={imageAlt}
        class="max-h-full max-w-full object-contain"
        on:click|stopPropagation
      >
    </div>
  </div>
{/if}
